import i18nFactory from '@yandex-int/i18n';

import { SaveAdGroup } from '../../typings/graphql-grid';
import { GroupId } from '../../typings/groups';

import * as keyset from './ErrorHelpers.i18n';

const i18n = i18nFactory(keyset);

export interface ErrorOrWarning {
    code: string;
    params: object | null;
    path: string;
}

type SavedGroupsResponse = null | Array<null | {
    adGroupId: string;
}>;

interface ErrorProneUpdateResponse extends ErrorProneResponse {
    updatedAdGroupItems?: SavedGroupsResponse;
}

interface ErrorProneResponse {
    validationResult: null | {
        errors: Array<ErrorOrWarning>;
        warnings: Array<ErrorOrWarning>;
    };
}

interface ErrorProneUpdateResponse extends ErrorProneResponse {
    updatedAdGroupItems?: SavedGroupsResponse;
}

export const extractValidationErrors = (apiHandleResponse: ErrorProneResponse): [boolean, ErrorOrWarning[]] => {
    if (!apiHandleResponse.validationResult) {
        return [false, []];
    }
    return [apiHandleResponse.validationResult.errors.length !== 0, apiHandleResponse.validationResult.errors];
};

export const extractSavedGroupIds = (apiResponse?: SaveAdGroup): Array<GroupId> => {
    if (!apiResponse) {
        return [];
    }

    const {
        addTextAdGroups,
        updateTextAdGroup,
        updateSmartAdGroups,
        updateMcBannerAdGroup,
        addContentPromotionAdGroups,
        updateContentPromotionAdGroups
    } = apiResponse;

    return [
        ...getSavedGroupsIds(addTextAdGroups.addedAdGroupItems),
        ...getSavedGroupsIds(updateTextAdGroup.updatedAdGroupItems),
        ...getSavedGroupsIds(updateSmartAdGroups.updatedAdGroupItems),
        ...getSavedGroupsIds(updateMcBannerAdGroup.updatedAdGroupItems),
        ...getSavedGroupsIds(addContentPromotionAdGroups.addedAdGroupItems),
        ...getSavedGroupsIds(updateContentPromotionAdGroups.updatedAdGroupItems)
    ];
};

export const getSavedGroupsIds = (apiResponse?: SavedGroupsResponse): Array<GroupId> => {
    if (!apiResponse) {
        return [];
    }

    return apiResponse.reduce((acc, item) => (!item ? acc : [...acc, item.adGroupId]), []);
};

export const extractUpdatedGroupIds = (apiHandleResponse: ErrorProneUpdateResponse): Array<GroupId> => {
    if (!apiHandleResponse.updatedAdGroupItems) {
        return [];
    }

    return apiHandleResponse.updatedAdGroupItems.reduce((acc, item) => {
        if (!item) {
            return acc;
        }

        return [...acc, item.adGroupId];
    }, []);
};

export const getErrorTextFromCountErrors = (errorsCount: number): string => {
    if (errorsCount === 1) {
        return i18n('one-block-error');
    }

    return i18n('block-errors', {
        count: errorsCount
    });
};
